import {Pipe, PipeTransform} from '@angular/core';
import {IErrorType} from "../interfaces/audit/IErrorType";
import {AuditingService} from "../services/auditing.service";

@Pipe({
  name: 'errorTypeToDisplay'
})
export class ErrorTypePipe implements PipeTransform {
  public errorTypes: IErrorType[] = this.auditingService.getErrorTypes();

  constructor(private auditingService: AuditingService) {
  }

  public transform(errorTypeValue: number): string {
    let errorType = this.errorTypes
      .find((currentErrorType) => errorTypeValue === currentErrorType.Value);

    if (errorType) {
      return errorType.Name;
    }

    return `Unknown Error (${errorTypeValue})`;
  }
}
